export const LIVE_CHAT_CONSTANTS = {
	defaultLiveChatId: 0
};
